import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Autocomplete, Chip, TextField } from "@mui/material"
import { getUsersByStations } from "redux/actions/users/usersActions";
import { PERMISSIONS } from "router/permissions";

const { ENDOWMENTS_SETTLEMENTS } = PERMISSIONS

export const UsersComponent = ({
    state,
    dispatchAction = () => null
}) => {
    const { usersStation } = useSelector(({ users }) => users);
    const dispatch = useDispatch();

    useEffect(() => {
        if (state?.station?.id) {
            dispatch(getUsersByStations( ENDOWMENTS_SETTLEMENTS,state?.station?.id));
        }
        dispatch(dispatchAction("user", null));
    }, [state?.station]);

    return (
        <Grid item xs={12} sm={3}>
            <Autocomplete
                id="combo-box-demo"
                options={usersStation}
                value={state?.user || null}
                getOptionLabel={option => option?.name || ""}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            variant="outlined"
                            label={option.label}
                            {...getTagProps({ index })}
                            style={{
                                borderRadius: 4
                            }}
                        />
                    ))
                }
                renderInput={params => (
                    <TextField
                        {...params}
                        label="Usuario"
                        variant="outlined"
                        size="small"
                    />
                )}
                fullWidth
                onChange={(e, v) => dispatch(dispatchAction("user", v))}
                noOptionsText="No se encuentra usuario"
            />
        </Grid>
    );
};
